export default __webpack_public_path__ + "static/media/active_cone_coins.eb54b4f3.png";